import type { DeleteInternalAuditReportsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

const mapTrpcResponseToGraphQL = (trpcData: {
  affected_rows: number;
}): DeleteInternalAuditReportsMutation => {
  return {
    delete_internal_audit_report: {
      __typename: 'internal_audit_report_mutation_response',
      affected_rows: trpcData.affected_rows,
    },
  };
};

export const useDeleteInternalAuditReportsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.internalAuditReport.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.internalAuditReport.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey:
            trpc.frontend.internalAuditReport.internalAuditReportCount.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey:
            trpc.frontend.internalAuditReport.internalAuditReportsByOriginatingItemId.queryKey(),
        });
      },
    }),
  });

  return {
    deleteInternalAuditReports: async (
      ids: string[]
    ): Promise<DeleteInternalAuditReportsMutation> => {
      const result = await mutation.mutateAsync({ Ids: ids });

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
